module.exports = "<div class=\"mat-dialog-container leftbar\" >\n    <app-left-bar style=\"left: 0px; padding: 0px\"></app-left-bar>\n</div>"